import {
  ViewChildren,
  QueryList,
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ViewContainerRef, Injector,
  DebugElement,
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Meta} from '@angular/platform-browser';
import {ChartsCommonFunctions} from 'src/app/shared/toolbox/charts/chartsCommonFunctions';
import * as Plotly from "plotly.js-dist-min";
import {ChartWrapperComponent} from "../../shared/toolbox/charts/chart-wrapper/chart-wrapper.component";

import {LineChartComponent} from "../../shared/toolbox/charts/line-chart/line-chart.component";
import { BarChartComponent} from "../../shared/toolbox/charts/bar-chart/bar-chart.component";


@Component({
  selector: 'app-public-chart',
  templateUrl: './public-chart.component.html',
  styleUrls: ['./public-chart.component.scss']
})
export class PublicChartComponent implements OnInit, AfterViewInit {
  @ViewChild('chartContainer', {static: false}) chartContainer!: ElementRef;
  @ViewChild('mainContainer', {static: false}) mainContainer!: ElementRef;



  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private meta: Meta,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private chartsCommonFunctions: ChartsCommonFunctions,
    public chartWrapper: ChartWrapperComponent,
  ) {
  }

  dataSystem: any = ''
  showChart: boolean = false
  params = this.route.snapshot.queryParams
  rcl: any = null
  chartType: any = null
  currentVisualizations: any = null
  retailer: any = null
  header: string | undefined = '';
  description: string | undefined = '';
  isIframe: boolean = false;
  sharedVis: any;
  textElementsDict: any;
  textElements: any;

  chartData: any
  chartAppType: string = ''

  payload: any
  idParts: any
  lastPart: any
  custom_chart_info: any
  componentMap: Record<string, any> = {};
  custom_chart_id: string | null = null;


  ngOnInit() {

    if (window.self !== window.top) {
      this.isIframe = true;

      const checkContainers = setInterval(() => {
        this.chartContainer = this.elementRef.nativeElement.querySelector('#chart-container');
        this.mainContainer = this.elementRef.nativeElement.querySelector('#main-container');


        if (this.chartContainer && this.mainContainer) {
          this.renderer.addClass(this.chartContainer, 'iframe-chart-container');
          this.renderer.removeClass(this.chartContainer, 'chart-container');
          this.renderer.addClass(this.mainContainer, 'iframe-main-container');
          this.renderer.removeClass(this.mainContainer, 'main-container');

          clearInterval(checkContainers); // Stop checking once elements are found
        }
      }, 100); // Check every 100ms
    }

    this.payload = {id: this.params['id']}
    this.idParts = this.payload.id.split('-');
    this.lastPart = this.idParts[this.idParts.length - 1];

    if (this.params['custom_id']) {
      this.getCustomChart()
    }


    if (this.params['s'] === 'rcl') {
      this.getRCLChart(this.payload, this.idParts, this.lastPart)
    } else if (this.params['s'] === 'sqa') {
      this.getSQAChart(this.params['id'])
    }
  }

  ngAfterViewInit() {
    const waitForComponentMap = (retries = 10, delay = 500) => {
      this.componentMap = {
        rdna_line: this.findComponent('app-line-chart'),
        rdna_heatmap: this.findComponent('app-heatmap'),
        rdna_box: this.findComponent('app-box-chart'),
        rdna_bar: this.findComponent('app-bar-chart'),
        rdna_pie: this.findComponent('app-pie-chart'),
        rdna_company_profile: this.findComponent('app-company-profile'),
        rdna_metric_table: this.findComponent('app-metric-table'),
        lb_bar: this.findComponent('app-lb-bar-chart'),
        lb_pie: this.findComponent('app-lb-pie-chart'),
      };

      let chartType: string | null = null;
      for (const key in this.componentMap) {
        if (this.componentMap[key]) {
          chartType = key; // Assign the first non-empty chart component's key
          break;
        }
      }

      if (chartType) {
        console.log("Component found");
        if (chartType !== 'rdna_company_profile' && chartType !== 'rdna_metric_table') {
          console.log("Initializing replayPlotlyChart...");
          this.replayPlotlyChart(chartType); // Call replayPlotlyChart after componentMap is filled
        }
      } else if (retries > 0) {
        console.warn(`Waiting for components... (${10 - retries} attempts remaining)`);
        setTimeout(() => waitForComponentMap(retries - 1, delay * 1.5), delay); // Exponential backoff
      } else {
        console.error("No chart components found after multiple attempts.");
      }
    };

    waitForComponentMap();
  }


  findComponent(selector: string) {
    const element = this.elementRef.nativeElement.querySelector(selector);
    return element ? this.renderer.selectRootElement(element, true) : null;
  }

  replayPlotlyChart(chartType: string): void {
    const component = this.componentMap[chartType];

    if (this.componentMap && component) {
      const tryGetComponent = (retries = 5, delay = 500) => {
        const componentInstance= (window as any).ng.getComponent(component);

        // console.log("componentInstance", componentInstance)

        if (componentInstance) {
          console.log("Component instance found, proceeding with rendering.");
          tryRenderPlot(componentInstance); // Call rendering function once the instance is available
        } else if (retries > 0) {
          console.warn(`Waiting for component instance... (${5 - retries} retries remaining)`);
          setTimeout(() => tryGetComponent(retries - 1, delay * 1.5), delay); // Retry with increasing delay
        } else {
          console.error("Component instance is not available after retries.");
        }
      };

      const tryRenderPlot = (componentInstance: any, retries = 5, delay = 500) => {
        const customPlotDiv = componentInstance?.plotlyChart;

        if (customPlotDiv) {
          Plotly.react(customPlotDiv, this.custom_chart_info.data, this.custom_chart_info.layout)
            .then(() => {
              console.log("New plot successfully rendered");

              if (this.custom_chart_id) {
                componentInstance.chartId = this.custom_chart_id;
              }
              console.log("Custom share chart rendered.");
            })
            .catch(error => console.error("Error rendering new plot:", error));
        } else if (retries > 0) {
          console.warn(`Retrying plot render... (${5 - retries} retries remaining)`);
          setTimeout(() => tryRenderPlot(componentInstance, retries - 1, delay), delay);
        } else {
          console.error("Plotly chart still not available after retries.");
        }
      };

      // Start the component retrieval process
      tryGetComponent();
    } else {
      console.error("Component not found in componentMap.");
    }
  }

  getRCLChart(payload: any, idParts: any, lastPart: any) {

    this.chartAppType = 'rdna'
    let url = `${environment.backend_base}main/visualizations/get_public_chart_data/`

    this.http.post(url, payload).subscribe((response: any) => {
      this.currentVisualizations = response.current_visualizations

      this.sharedVis = this.currentVisualizations.find(
        (viz: any) => viz.id === Number(lastPart)
      );
      // console.log(this.sharedVis)
      this.textElementsDict = this.sharedVis.text_elements;

      this.rcl = response.rcl
      this.chartType = response.chartType


      if (response.retailer?.name) {
        this.retailer = response.retailer
        this.textElements = this.textElementsDict.retailer
        //this.textElements = this.chartsCommonFunctions.getTextElements(this.textElements, response.retailer) //TODO: get retailer and list profile
        if (this.chartType.chart_type !== "companyprofile" && this.chartType.chart_type === "metrictable") {
          this.header = this.textElements.header
          this.description = this.textElements.subheader
        }

      } else {
        this.textElements = this.textElementsDict.list;
        //this.textElements = this.chartsCommonFunctions.getTextElements(this.textElements, )
        if (this.chartType.chart_type !== "companyprofile" && this.chartType.chart_type === "metrictable") {
          this.header = this.textElements.header;
          this.description = this.textElements.subheader;
        }
      }

      this.chartData = {
        chartType: this.chartType,
        rcl_id: this.rcl.id,
        retailer: this.retailer,
        visualization: this.currentVisualizations
      }
      console.log(this.chartData)
      this.showChart = true
    })
  }

  getSQAChart(sqa_id: any) {
    this.chartAppType = 'lb'

    this.chartData = {
      visualization: [{
        sqa_chart_id: Number(sqa_id)
      }]
    }
    this.showChart = true
  }

  getCustomChart() {

    let url = `${environment.backend_base}main/visualizations/get_public_custom_chart_data/`
    let payload = {id: this.params['custom_id']}

    this.http.post(url, payload).subscribe(
      (response: any) => {
        try {
          this.custom_chart_info = JSON.parse(response.custom_chart_info.chart_content);
          this.custom_chart_id = response.custom_chart_info.custom_id;
          console.log("Custom chart information retrieved successfully.");
        } catch (error) {
          console.error("JSON Parsing Error:", error);
        }
      },
      (error) => {
        console.error("Error getting custom chart:", error);
      })
  }
}
